export const TENANT_APP_USER_ROLE_KEYS = ["agentiq_admin", "agentiq_editor"] as const;

export type TenantAppUserRoleKey = (typeof TENANT_APP_USER_ROLE_KEYS)[number];

export interface TenantAppUserRoleDefinition {
  key: TenantAppUserRoleKey;
  label: string;
  description: string;
}

export const TENANT_APP_USER_ROLE_DEFINITIONS: readonly TenantAppUserRoleDefinition[] = [
  {
    key: "agentiq_admin",
    label: "Agentiq Admin",
    description: "Can manage user access settings and other tenant administration inside Agentiq.",
  },
  {
    key: "agentiq_editor",
    label: "Agentiq Editor",
    description:
      "Can work with Agentiq content and configuration without tenant user administration.",
  },
];

const TENANT_APP_USER_ROLE_LABELS = new Map(
  TENANT_APP_USER_ROLE_DEFINITIONS.map((role) => [role.key, role.label] as const),
);

export function isTenantAppUserRoleKey(value: string): value is TenantAppUserRoleKey {
  return TENANT_APP_USER_ROLE_KEYS.includes(value as TenantAppUserRoleKey);
}

export function findInvalidTenantAppUserRoleKeys(values: readonly string[] | undefined): string[] {
  return Array.from(
    new Set(
      (values ?? [])
        .map((value) => value.trim())
        .filter(Boolean)
        .filter((value) => !isTenantAppUserRoleKey(value)),
    ),
  ).toSorted();
}

export function normalizeTenantAppUserRoleKeys(
  values: readonly string[] | undefined,
): TenantAppUserRoleKey[] {
  return Array.from(
    new Set((values ?? []).map((value) => value.trim()).filter(isTenantAppUserRoleKey)),
  ).toSorted();
}

export function getTenantAppUserRoleLabel(roleKey: TenantAppUserRoleKey): string {
  return TENANT_APP_USER_ROLE_LABELS.get(roleKey) ?? roleKey;
}

export function formatTenantAppUserRoleLabels(roleKeys: readonly TenantAppUserRoleKey[]): string[] {
  return roleKeys.map(getTenantAppUserRoleLabel);
}
